import { xVerifyApi } from '_api';
import { FIELD_KEYS } from '_constants/forms';

export const validateEmail = (options) => async (value) => {
  if (!value) {
    return true;
  }

  let validationResult = true;
  const { setProcessing, useEmailVerificationService } = options || {};

  if (useEmailVerificationService === false) {
    return validationResult;
  }

  if (setProcessing) {
    setProcessing(true);
  }

  let emailValue = value;

  if (emailValue.indexOf('+') > -1 && emailValue.indexOf('gmail.com') > -1) {
    emailValue =
      emailValue.substring(0, emailValue.indexOf('+')) +
      emailValue.substring(emailValue.indexOf('@'), emailValue.length);
  }

  const { status, reason } = await xVerifyApi.verifyEmail(emailValue);

  if (xVerifyApi.INVALID_EMAIL_STATUSES.includes(status)) {
    const defaultMessage = 'Email address is not valid';

    validationResult = xVerifyApi.VALIDATION_MESSAGE[reason] || defaultMessage;
  }

  if (setProcessing) {
    setProcessing(false);
  }

  return validationResult;
};

export const validatePhone = () => (value) => {
  if (!value) {
    return true;
  }

  const pureNumber = value.replace(/\D/g, '');

  if (pureNumber.length !== 10) {
    return 'Phone number should be equal 10 symbols';
  }

  return true;
};

export const validateConfirmation = (options) => async (value) => {
  const { values } = options || {};

  if (value !== values[FIELD_KEYS.newPassword]) {
    return "Password didn't match";
  }

  return true;
};

export const validateNewPassword = () => (value) => {
  const hasDigit = new RegExp(/^(?=.*\d).*$/);
  const hasUpperLetter = new RegExp(/^(?=.*[A-Z]).*$/);
  const hasLowerLetter = new RegExp(/^(?=.*[a-z]).*$/);
  const hasSpecialSymbol = new RegExp(/^(?=.*[!@#$%^&*]).*$/);
  const complexCheck = new RegExp(/^[a-zA-Z0-9!@#$%^&*]+$/);

  if (!hasDigit.test(value)) {
    return 'Password must contain at least one digit';
  }

  if (!hasUpperLetter.test(value)) {
    return 'Password must contain at least one uppercase letter';
  }

  if (!hasLowerLetter.test(value)) {
    return 'Password must contain at least one lowercase letter';
  }

  if (!hasSpecialSymbol.test(value)) {
    return 'Password must contain at least one special symbol';
  }

  if (!complexCheck.test(value)) {
    return 'Only latin letters are allowed';
  }

  return true;
};

export const validateAddress = () => (value) => {
  if (!value) {
    return true;
  }

  if (
    !/(?!.*(?:[pP][oO] [bB][oO][xX]))^[ a-zA-Z0-9\\/-]+$/.test(value) ||
    !/(?!.*(?:[pP][oO][bB][oO][xX]))^[ a-zA-Z0-9\\/-]+$/.test(value) ||
    !/(?!.*(?:[pP][oO][sS][tT] [oO][fF][fF][iI][cC][eE] [bB][oO][xX]))^[ a-zA-Z0-9\\/-]+$/.test(value) ||
    // eslint-disable-next-line no-useless-escape
    /\bP(ost|ostal)?([ \.]*(O|0)(ffice)?)?([ \.]*Box)\b/i.test(value)
  ) {
    return 'PO Boxes are not acceptable';
  }

  return true;
};

export const validateCardNumber = (options) => (value) => {
  const { erroredFields } = options || {};
  const isTestCard = value === '0000000000000000';

  return !isTestCard && erroredFields.cardNumber ? erroredFields.cardNumber : true;
};

export const validateCVC = (options) => () => {
  const { erroredFields } = options || {};
  return erroredFields.cvc || true;
};

export const validateCardMonth = (options) => (value) => {
  const { values, clearErrors, checkIfCardExpired } = options || {};

  const isCardExpired = checkIfCardExpired({
    cardMonth: value,
    cardYear: values[FIELD_KEYS.cardYear],
  });

  if (!isCardExpired) {
    clearErrors && clearErrors(FIELD_KEYS.cardYear);
  }

  return isCardExpired && values[FIELD_KEYS.cardYear] ? 'This card expired' : true;
};

export const validateCardYear = (options) => (value) => {
  const { values, clearErrors, checkIfCardExpired } = options || {};

  const isCardExpired = checkIfCardExpired({
    cardMonth: values[FIELD_KEYS.cardMonth],
    cardYear: value,
  });

  if (!isCardExpired) {
    clearErrors && clearErrors(FIELD_KEYS.cardMonth);
  }

  return isCardExpired && values[FIELD_KEYS.cardMonth] ? 'This card expired' : true;
};

export const validateStartDate = (options) => (value) => {
  const { values } = options || {};

  if (values[FIELD_KEYS.endDate] && values[FIELD_KEYS.endDate] < value) {
    return 'Start Date cannot be after End Date';
  }

  return true;
};

export const validateEndDate = (options) => (value) => {
  const { values } = options || {};

  if (values[FIELD_KEYS.startDate] && values[FIELD_KEYS.startDate] > value) {
    return 'End Date cannot be before Start Date';
  }

  return true;
};
